module.exports = __webpack_public_path__ + "img/terminate.447e4ca9.svg";